__turbopack_context__.v({
  "wrapper": "MaxWidth-module__d4AudW__wrapper",
});
